import type { AuthenticatedUser } from "@gettactic/api";

export function isTacticStaff(user?: AuthenticatedUser) {
  return (
    user?.user?.email &&
    (user.user.email.endsWith("@gettactic.com") ||
      user.user.email.endsWith("@tactic-staging.com") ||
      user.user.email.endsWith("@gettactic.onmicrosoft.com") ||
      process.env.NODE_ENV === "development")
  );
}
